import { EncryptionGeofencingCountryEntity } from '../entities';
import { authResource } from './Auth';
export const EncryptionGeofencingCountryResource = authResource({
    path: '/encryptions/:encryptionId/geofencing/countries/:countryId?',
    searchParams: {},
    schema: EncryptionGeofencingCountryEntity
}).extend('partialUpdate', {
    body: {
        addCountryIds: [],
        removeEncryptionGeofencingCountryIds: []
    },
    schema: undefined
});
